module.exports = __webpack_public_path__ + "static/media/[Philm]2010-07-17-4.9f089c35.md";